import localStore from 'store2';
var Keys;

(function (Keys) {
  Keys["useAnalyticsMock"] = "USE_ANALYTIC_MOCK";
})(Keys || (Keys = {}));

var GlobalConfigCls =
/** @class */
function () {
  function GlobalConfigCls() {}

  GlobalConfigCls.prototype.isAnalyticsUsingMock = function () {
    return Boolean(localStore.get(Keys.useAnalyticsMock));
  };

  GlobalConfigCls.prototype.setUseAnalyticsMock = function (isUsingMock) {
    localStore.set(Keys.useAnalyticsMock, isUsingMock);
  };

  return GlobalConfigCls;
}();

export var GlobalConfig = new GlobalConfigCls();